<template>
  <v-container>
    <v-form ref="form" v-model="valid" lazy-validation class="pt-0 pl-3 pr-3 pb-3 mt-2">

      <v-card class="mx-auto pl-3 pr-3 mt-6" outlined>
        <v-card-subtitle> <strong style="color:blue">1.</strong> Información del pago</v-card-subtitle>
        <v-row>
          <v-col cols="12" sm="4">
            <v-label>País</v-label>
            <v-text-field value="Perú" outlined dense disabled></v-text-field>
          </v-col>
          <v-col cols="12" sm="8">
            <v-label>Monto a pagar en : PEN (mín. 200 — máx. {{ maxAmount }})</v-label>
            <v-text-field v-model="plan.amount" outlined dense required type="number" :min="200" :max="maxAmount"
              prefix="$" :rules="amountRules"></v-text-field>
          </v-col>
        </v-row>

        <v-card-subtitle> <strong style="color:blue">2.</strong> Descripción del pago</v-card-subtitle>
        <p>{{ createdDescription }}</p>
      </v-card>

      <v-btn block class="mt-3 pt-5 pb-5" dark color="primary" @click="validate()">
        Generar Link de pago
      </v-btn>
    </v-form>

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="800">
        <v-toolbar color="primary" dark class="mb-0" stick>
          <v-toolbar-title>Detalle del link de pago</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="showUrl" icon dark @click="dialog = closeall()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card class="mx-auto " max-width="800" :loading="loading">
          <div v-if="!showUrl">
            <v-list subheader three-line>
              <v-list-item>
                <v-list-item-content class="mt-2">
                  <v-list-item-title>
                    <v-icon class="mb-1 mr-1" color="primary">mdi-account-school</v-icon> Información del
                    Estudiante</v-list-item-title>
                  <v-divider></v-divider>
                  <div>
                    <v-row no-gutters>
                      <v-col cols="12" sm="2">
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title>DNI</v-list-item-title>
                            <v-list-item-subtitle>{{ student.dni }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title>Nombre</v-list-item-title>
                            <v-list-item-subtitle>{{ student.name }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title> Email</v-list-item-title>
                            <v-list-item-subtitle>{{ student.email }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title> Télefono</v-list-item-title>
                            <v-list-item-subtitle>{{ student.phone }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </div>

                  <div class="mt-4">
                    <v-list-item-title class="font-weight-medium"> <v-icon class="mb-1 mr-1"
                        color="primary">mdi-school</v-icon> Información del
                      Programa </v-list-item-title>
                    <v-divider></v-divider>
                    <v-row no-gutters>
                      <v-col cols="12" sm="5">
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title>Nombre</v-list-item-title>
                            <v-list-item-subtitle>{{ program.name }} </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title>Código</v-list-item-title>
                            <v-list-item-subtitle>{{ program.codeProgram }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title> Tipo de Programa</v-list-item-title>
                            <v-list-item-subtitle>{{ program.programType }} </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </div>

                  <div class="mt-6">
                    <v-list-item-title> <v-icon class="mb-1 mr-1" color="primary">mdi-credit-card</v-icon> Información
                      del Pago</v-list-item-title>
                    <v-divider></v-divider>
                    <v-row no-gutters>
                      <v-col cols="12" sm="4">
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title> País</v-list-item-title>
                            <v-list-item-subtitle>Perú</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title> Moneda</v-list-item-title>
                            <v-list-item-subtitle>{{ plan.currency }} </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title> Monto a pagar</v-list-item-title>
                            <v-list-item-subtitle>{{ plan.amount }} </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </div>

                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" dark @click="dialog = false" :disabled="loading">
                Cancelar
              </v-btn>
              <v-btn color="primary" dark @click="createUrl()" :loading="loading">
                Crear link de pago
              </v-btn>
            </v-card-actions>
            <v-alert v-if="msgerror" type="info" dense text class="mt-2" color="red">
              {{ msgerror }}
            </v-alert>
          </div>
          <div v-else>
            <v-list-item>
              <v-list-item-content class="mt-2">
                <v-list-item-title>
                  <v-icon class="mb-1 mr-1" color="primary">mdi-link-variant</v-icon> Link de pago único generado
                </v-list-item-title>
                <v-divider></v-divider>

                <div style='background: #f9fafb; border-radius: 10px; height: 80px; margin-top: 10px;'>
                  <v-row no-gutters class="mt-2">
                    <v-col cols="12" sm="4">
                      <v-list-item two-line>
                        <v-list-item-content style="border-left: 1px solid #0066ff; padding-left: 10px;">
                          <v-list-item-title> Estudiante</v-list-item-title>
                          <v-list-item-subtitle>{{ student.name }} </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-list-item two-line>
                        <v-list-item-content style="border-left: 1px solid #0066ff; padding-left: 10px;">
                          <v-list-item-title> Moneda</v-list-item-title>
                          <v-list-item-subtitle>{{ plan.currency }} </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-list-item two-line>
                        <v-list-item-content style="border-left: 1px solid #0066ff; padding-left: 10px;">
                          <v-list-item-title> Monto</v-list-item-title>
                          <v-list-item-subtitle>{{ plan.amount }} </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </div>
                <v-row no-gutters>
                  <p class="mt-5 font-weight-medium">Copia y pega este link de pago</p>
                  <v-col sm="10">
                    <v-text-field prepend-inner-icon="mdi-link" outlined dense disabled
                      v-model="urlCheckOut"></v-text-field>
                  </v-col>
                  <v-col sm="2">
                    <v-btn color="light-blue darken-2" dark style="margin-left: -33px; margin-top:1.5px;"
                      @click="copylink()">
                      <v-icon left>
                        mdi-content-copy
                      </v-icon>
                      {{ txtboton }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable */
import eventBus from '@/common/EventBus'
import planServices from '@/services/plan.services'

export default {
  name: "CreatePaymentLink",

  data() {
    return {
      msgerror: '',
      showUrl: false,
      valid: false,
      dialog: false,
      loading: false,
      urlCheckOut: '',
      txtboton: ' Copiar Link',
      minAmount: 200,
      maxAmount: 0,
      plan: {
        name: '',
        description: '',
        country: 'PE',
        currency: 'PEN',
        amount: '',
        createby: 0,
        payerId: 0,
        programId: 0
      },
      student: {},
      program: {},
    }
  },
  mounted() {
    eventBus.on('set-create-paymentlink', () => {
      this.student = {};
      this.program = {};
      this.student = JSON.parse(localStorage.getItem('studentls'));
      this.program = JSON.parse(localStorage.getItem('programls'));
      // País fijo Perú → moneda PEN; el máximo es el precio del programa seleccionado
      this.plan.country = 'PE';
      this.plan.currency = 'PEN';
      this.maxAmount = Number(this.program.price) || 0;
      this.plan.amount = '';
      this.showUrl = false;
    });
  },
  methods: {
    validate() {
      if (this.$refs.form.validate())
        this.reviewPay();
    },

    reviewPay() {
      this.plan.name = this.program.name + ' - ' + this.student.dni;
      this.plan.payerId = this.student.id;
      this.plan.programId = this.program.id;
      this.plan.description = this.createdDescription;
      this.dialog = true;
    },

    createUrl() {
      this.loading = true;
      this.plan.createby = this.$store.state.auth.user.id;
      planServices.postCreatePaymentLink(this.plan).then(response => {
        this.loading = false;
        this.showUrl = true;
        // El link apunta al formulario de checkout interno; al finalizar
        // el estudiante es redirigido al pago único de MercadoPago.
        this.urlCheckOut = process.env.VUE_APP_URL_CHECKOUT + response.data.guid;
      },
        error => {
          this.loading = false;
          this.msgerror = 'Ha ocurrido un error al crear el link de pago, intente nuevamente';
          setTimeout(() => {
            this.msgerror = ''
          }, 2500);
          console.log(error, 'error al crear link de pago');
        })
    },

    copylink() {
      navigator.clipboard.writeText(this.urlCheckOut);
      this.txtboton = 'Copiado...';
    },

    closeall() {
      this.dialog = false;
      localStorage.removeItem('studentls');
      localStorage.removeItem('programls');
      this.$router.go();
    }
  },
  computed: {
    amountRules() {
      return [
        v => (v !== null && v !== undefined && v.toString().trim() !== '') || 'Debe ingresar un monto',
        v => (Number(v) >= this.minAmount) || `El monto mínimo es ${this.minAmount} PEN`,
        v => (this.maxAmount > 0 && Number(v) <= this.maxAmount) || `El monto máximo es ${this.maxAmount} PEN`,
      ];
    },
    createdDescription: function () {
      const monto = this.plan.amount ? this.plan.amount : '---';
      return 'Pago único de ' + monto + ' PEN para el programa ' + (this.program.name || '');
    }
  }
}
</script>

<style scoped>
.v-label {
  color: #666161;
  font-weight: 400;
  font-size: 11pt
}

.v-card__subtitle {
  padding: 0;
  padding-top: 15px;
  padding-bottom: 20px;
}

.v-text-field--outlined>>>fieldset {
  border-color: #dfe5ef
}
</style>
